const categoryLangs = {
  categoryList: {
    title: "Danh mục hàng hóa",
  },
  categoryDetail: {
    title: "Chi tiết hàng hóa: {{name}}",
  },
  categoryAdd: {
    title: "Thêm danh mục",
  },
  success: {
    categoryAdd: "Thêm danh mục thành công",
    categoryEdit: "Cập nhật danh mục thành công",
    categoryDelete: "Xóa danh mục thành công",
  },
  error: {
    categoryList: "lấy danh mục hàng hóa lỗi",
    categoryAdd: "Thêm danh mục lỗi",
    categoryEdit: "Cập nhật danh mục lỗi",
    categoryDelete: "Xóa danh mục lỗi",
  },
};

export default categoryLangs;
